<template>
  <div>
    <ul class="list-unstyled rates-additional-info">
      <li
        v-for="(ext, i) in row.flatMap(r => r.rateData.rate.extra)"
        :key="i"
      >
        <bridge8-popover
          header-prefix="Extra Rate: "
          trigger="click"
          :text-callback="obj => obj.type"
          :fields="['type']"
          :obj="ext.rate && {type: ext.rate.type}"
        />
        <span class="price-display" v-if="ext.price.display">
          <mdb-icon
            v-if="ext.price && (ext.price.amount === null)"
            icon="exclamation"
            class="text-warning"
          />
          &nbsp;{{ ext.price.display }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mdbIcon } from 'mdbvue'
import Bridge8Popover from './Bridge8Popover'

export default {
  name: 'CalcRatesTableCellExtra',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  components: {
    mdbIcon,
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellExtra.vue